if (!customElements.get('variant-load-more-options')) {
  class VariantLoadMoreOptions extends HTMLElement {
    constructor () {
      super();
    }

    disconnectedCallback () {
      this.removeEventListener('click', this.clickHandle.bind(this));
    }

    clickHandle () {
      this.classList.add('hidden');
      this.parentElement.querySelectorAll('.variant-input.hidden').forEach((item) => {
        item.classList.remove('hidden');
      });
    }

    connectedCallback () {
      this.addEventListener('click', this.clickHandle.bind(this));
    }
  }

  customElements.define('variant-load-more-options', VariantLoadMoreOptions);

}